import React from "react";

const StudentVisa = () => {
  return <div>StudentVisa</div>;
};

export default StudentVisa;
